// LL-HLS detection from a playlist body. LL-HLS is per-distributor and OFF by
// default, and the tags live on the *media* playlist — so we detect rather than
// assume. The managed player uses this on level updates to report isLowLatency.

const LOW_LATENCY_TAG = /^#EXT-X-(PART-INF|PART|PRELOAD-HINT)[:\s]/m;

export function isLowLatencyManifest(playlistText: string): boolean {
  return LOW_LATENCY_TAG.test(playlistText);
}
